import React, { useEffect } from "react";
import { Button, Col, Form, Input, Row, Space } from "antd";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";

import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";
import * as String from "../commons/string";
import * as TypeUtils from "../commons/typeUtils";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RegisterColor({ editMode, color, onRegisterColor }: { editMode: TypeUtils.editMode; color?: Types.ColorDto; onRegisterColor?: () => void }) {
    const alert = useAlert();
    const [form] = Form.useForm();

    //add color
    const requestAxiosAddColor = async (data: Types.ColorDto) => {
        const response = await utilAxiosWithAuth().post(Request.COLOR_URL, data);
        return response.data;
    };

    const { loading: loadingAddColor, error: errorAddColor, data: resultAddColor, execute: requestAddColor } = useAsyncAxios(requestAxiosAddColor);

    useEffect(() => {
        if (color === undefined) return;

        form.setFieldsValue(color);
    }, [color]);

    useEffect(() => {
        if (resultAddColor === null) return;
        if (onRegisterColor) onRegisterColor();

        alert.setAlert(AlertType.SUCCESS, String.color + String.addSuccess, String.color + String.msgAddSuccess);
    }, [resultAddColor]);

    useEffect(() => {
        if (errorAddColor === null) return;

        alert.setAlert(errorAddColor.response.data.code, String.color + String.addError, errorAddColor.response.data.message);
    }, [errorAddColor]);

    //update color
    const requestAxiosUpdateColor = async (data: Types.ColorDto) => {
        const response = await utilAxiosWithAuth().put(Request.COLOR_URL + "/" + data.colorId, data);
        return response.data;
    };

    const {
        loading: loadingUpdateColor,
        error: errorUpdateColor,
        data: resultUpdateColor,
        execute: requestUpdateColor,
    } = useAsyncAxios(requestAxiosUpdateColor);

    useEffect(() => {
        if (resultUpdateColor === null) return;
        if (onRegisterColor) onRegisterColor();

        alert.setAlert(AlertType.SUCCESS, String.color + String.updateSuccess, String.color + String.msgUpdateSuccess);
    }, [resultUpdateColor]);

    useEffect(() => {
        if (errorUpdateColor === null) return;

        console.log("errorUpdateColor", errorUpdateColor);
        alert.setAlert(errorUpdateColor.response.data.code, String.color + String.updateError, errorUpdateColor.response.data.message);
    }, [errorUpdateColor]);

    const onFinish = (values: any) => {
        delete values["confirm"];
        const data: Types.ColorDto = {
            ...values,
        };

        if (editMode === "add") requestAddColor(data);
        else if (editMode === "update") requestUpdateColor(data);
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <Row>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="colorId" label={String.color + String.ID}>
                                <Input readOnly disabled />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="colorName"
                                label={String.color + String.name}
                                rules={[
                                    {
                                        required: true,
                                        message: String.color + String.msgInputName,
                                    },
                                ]}
                            >
                                <Input disabled={editMode === "none"} placeholder={String.color + String.msgInputName} />
                            </Form.Item>
                        </Col>
                    </Row>
                    {editMode !== "none" && (
                        <Row justify="end">
                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    {editMode === "add" ? "등록" : "수정"}
                                </Button>
                            </Form.Item>
                        </Row>
                    )}
                </Space>
            </Form>
        </div>
    );
}

export default RegisterColor;
